import { Outlet, Navigate } from "react-router-dom";
import { useTokenRefresh } from "../hooks/useTokenRefresh";

function parseJwt(token) {
  const parts = token.split(".");
  if (parts.length !== 3) throw new Error("Invalid JWT format");
  const base64 =
    parts[1].replace(/-/g, "+").replace(/_/g, "/") +
    "==".slice(2 - (parts[1].length % 4));
  const json = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );
  return JSON.parse(json);
}

const checkAuth = () => {
  const token = localStorage.getItem("authToken");
  const refreshToken = localStorage.getItem("refreshToken");
  const companyName = localStorage.getItem("companyName");


  // No token - not authenticated
  if (!token) {
    return { authenticated: false, hasValidClient: false, missingAdminName: false };
  }

  // Token'da adminName kontrolü
  try {
    const decoded = parseJwt(token);
    if (!decoded.adminName) {
      return { authenticated: false, hasValidClient: false, missingAdminName: true };
    }
  } catch (e) {
    return { authenticated: false, hasValidClient: false, missingAdminName: true };
  }

  // Token exists, check for valid client
  if (!companyName || companyName === "DefaultClient") {
    return { authenticated: true, hasValidClient: false, missingAdminName: false };
  }

  // Check if companyName has corresponding data in localStorage
  const companyData = localStorage.getItem(companyName);
  if (!companyData) {
    return { authenticated: true, hasValidClient: false, missingAdminName: false };
  }

  return { authenticated: true, hasValidClient: true, missingAdminName: false };
};

const ProtectedRoutes = () => {

  // Token yenileme mekanizmasını başlat
  useTokenRefresh();

  const { authenticated, hasValidClient, missingAdminName } = checkAuth();

  
  if (!authenticated || missingAdminName) {
    if (missingAdminName) {
    } else {
    }
    return <Navigate to="/login" />;
  }

  if (!hasValidClient) {
    return <Navigate to="/client" />;
  }

  return <Outlet />;
};

export default ProtectedRoutes;
